<template>
	<v-menu offset-y class="menu" >
		<template v-slot:activator="{ on, attrs }">
			<div class="more-menu" v-bind="attrs" v-on="on">
				<MoreHoriz :color="color" />
			</div>
		</template>
		<div v-for="item in menulists_filter"
			:key="item.key"
			@click="onClick(item.usable, item.key)" 
			@mouseover="item.isHover = true"
			@mouseout="item.isHover = false"
			class="d-print-none" >
			<div :class="`menu-item ${item.usable? 'menu-able': 'menu-disable'}`">
				<component 
					:is="item.icon"
					:color="item.color"
					:selected="item.isHover" 
					:selected_color="'#81CC00'" 
					class="menu-icon" 
				/>
				{{ item.title }}
			</div>
		</div>
		<v-divider class="menu-divider d-print-none"></v-divider>
		<div :class="`d-print-none menu-delete  ${isOwned ? 'menu-delete-able': 'menu-delete-disable'}`" 
			@click="onDelete()" 
			@mouseover="isHover = true"
			@mouseout="isHover = false">
			<Delete width="18" height="18" class="mr-4" 
				:color="isOwned ? '#192A3E': '#82899B'"
				:selected="isHover && isOwned" 
				:selected_color="'#F45252'"/>
			<div>Delete</div>
		</div>
	</v-menu>
</template>
<script>
import MoreHoriz from "@/components/icons/more-horiz";
import ShowSearch from '@/components/icons/show_search';
import Share from '@/components/icons/share';
import Pin from '@/components/icons/unpin';
import UnPin from '@/components/icons/pin';

import Rename from '@/components/icons/rename';
import Copy from '@/components/icons/copy';
import Delete from '@/components/icons/delete_outline';

const SHOW_COLOR = '#192A3E';
const UNSHOW_COLOR = '#82899B';

const MENU_LIST = [
	{
		key: 'search',
		title: 'Show Search',
		icon: ShowSearch,
		color: SHOW_COLOR,
		usable: true,
		isHover: false
	},
	{
		key: 'share',
		title: 'Share',
		icon: Share,
		color: SHOW_COLOR,
		usable: true,
		isHover: false
	},
	{
		key: 'pin',
		title: 'Pin',
		icon: Pin,
		color: SHOW_COLOR,
		usable: true,
		isHover: false
	},
	{
		key: 'rename',
		title: 'Rename',
		icon: Rename,
		color: SHOW_COLOR,
		usable: true,
		isHover: false
	},
	{
		key: 'save',
		title: 'Save as ...',
		icon: Copy,
		color: SHOW_COLOR,
		usable: true,
		isHover: false
	}
];

export default {
	name: 'TaskMenu',
	props: {
		isOwned: {
			type: Boolean,
			default: false
		},
		isPinned: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: 'rgba(25, 42, 62, 0.7)'
		}
	},
	data() {
		return {
			menu_list: MENU_LIST,
			isHover: false,
		}
	},
	components: {
		MoreHoriz,
		ShowSearch,
		Share,
		Pin,
		UnPin,
		Rename,
		Delete,
		Copy
	},
	computed: {
		menulists_filter () {
			const arr = [];
			this.menu_list.forEach(menu => {
				const menu_tmp = {
					color: menu.color,
					icon: menu.icon,
					isHover: menu.isHover,
					key: menu.key,
					title: menu.title,
					usable: menu.usable
				};

				if (menu.key === 'rename' || menu.key === 'share') {
					menu_tmp['color'] = this.isOwned ? SHOW_COLOR: UNSHOW_COLOR;
					menu_tmp['usable'] = this.isOwned ? true : false;
					menu_tmp['search'] = this.isOwned ? true : false;
				}

				if (menu.key === 'pin') {
					menu_tmp['title'] = this.isPinned ? 'UnPin': 'Pin';
					menu_tmp['icon'] = this.isPinned ? UnPin: Pin;
					menu_tmp['color'] = this.isPinned ? UNSHOW_COLOR: SHOW_COLOR;
				}

				arr.push(menu_tmp);
			});

			return arr;
		}
	},
	methods: {
		onClick(usable, key) {
			if (usable) {
				if (key === 'pin') {
					const param = {
						key: key,
						enabled: !this.isPinned
					}
					this.$emit('click-menu-item', param)
				} else {
					this.$emit('click-menu-item', key);
				}
				
			}
		},
		onDelete() {
			if (this.isOwned) {
				this.$emit('delete');
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.more-menu {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}
.menu-item {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 16px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  background: #FAFAFA;
}
.menu-able {
	color: #192A3E;
	&:hover {
    color: #81CC00;
		cursor: pointer;
	}
}
.menu-disable {
	color: #82899B;
}
.menu-icon {
  width: 14px;
  height: 14px;
  margin-right: 20px;
}
.menu-divider {
  margin: 0 6px;
	border-color: #C4C4C4;
}
.menu-delete {
	display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
 	padding: 10px 16px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  background: #FAFAFA;
}
.menu-delete-able {
	color: #192A3E;
  &:hover {
    color: #F45252;
    font-weight: 500;
    cursor: pointer;
  }
}
.menu-delete-disable {
  color: #82899B;
}

</style>